import { RadioGroup as MuiRadioGroup } from "@mui/material";
import {
  type AriaAttributes,
  type ChangeEvent,
  type ReactNode,
  type Ref,
} from "react";

export type RadioGroupProps = AriaAttributes & {
  defaultValue?: unknown;
  value?: unknown;
  onChange?: (event: ChangeEvent<HTMLInputElement>, value: string) => void;
  name?: string;
  row?: boolean;
  children?: ReactNode;
  id?: string;
  className?: string;
  ref?: Ref<HTMLDivElement>;
};

export function RadioGroup({ children, ref, ...props }: RadioGroupProps) {
  return (
    <MuiRadioGroup {...props} ref={ref}>
      {children}
    </MuiRadioGroup>
  );
}
